import { configureStore } from '@reduxjs/toolkit'
import questionReducer from './slices/questionReducer'


export const store = configureStore({
  reducer: {
    question:questionReducer
  },
})